import { render, staticRenderFns } from "./formUpload_Central.vue?vue&type=template&id=6e456c61&"
import script from "./formUpload_Central.vue?vue&type=script&lang=js&"
export * from "./formUpload_Central.vue?vue&type=script&lang=js&"
import style0 from "./formUpload_Central.vue?vue&type=style&index=0&id=6e456c61&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports